module.exports = __webpack_public_path__ + "img/16-01_Working Well With Authority.a48add7e.svg";